import axiosRetry from 'axios-retry'

class Video {
  baseUrl = '//' + window.location.hostname

  getVideos = async () => {
    axiosRetry(axios, {
      retries: 3, 
      retryCondition: () => true, 
      retryDelay: (retryCount) => {
        return retryCount * 1000
      }
    })
    let resp = await axios.get(`${this.baseUrl}/api/videos`)
    return resp.data
  }

  getVideoById = async (id) => {
    axiosRetry(axios, {
      retries: 3, 
      retryCondition: () => true, 
      retryDelay: (retryCount) => {
        return retryCount * 1000
      }
    })
    let resp = await axios.get(`${this.baseUrl}/api/videos/${id}`)
    return resp.data
  }
}

export default Video 